import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M5.283 15.574l2.319-2.319C5.806 12.665 4.5 10.994 4.5 9c0-2.302 1.736-4.179 3.966-4.446l2.13-2.129L8.211.039C3.611.439 0 4.295 0 8.999c0 4.488 3.289 8.199 7.586 8.878l-2.303-2.303z" />
    <path d="M10.414.121l2.303 2.303-2.319 2.319C12.194 5.333 13.5 7.005 13.5 9c0 2.303-1.736 4.18-3.967 4.446l-2.128 2.128 2.385 2.385c4.6-.4 8.21-4.256 8.21-8.96C18 4.511 14.711.801 10.414.121z" />
  </svg>
);

export default SvgComponent;
